import React, { useState } from "react";
import { Flex } from "@chakra-ui/react";
import ServicesHeader from "./ServicesHeader";
import ServicesSearchBar from "./ServicesSearchBar";
import ServicesTable from "./ServicesTable";
import useServicesData from "./hooks/useServicesData";
import { toggleHiddenAction, toggleTestAction } from "./servicesActions";

/**
 * Admin page for browsing services and toggling their visibility / test flags.
 * Single data hook drives both /last (default) and /search (when typing).
 * Toggle actions update the local state optimistically and roll back on failure.
 * @returns {React.ReactElement}
 */
function Services() {
  const [query, setQuery] = useState("");
  const { items, setItems, loading, error, active } = useServicesData(query);

  const handleToggleHidden = (service) => toggleHiddenAction({ service, items, setItems });
  const handleToggleTest = (service) => toggleTestAction({ service, items, setItems });

  return (
    <Flex direction="column" gap="20px">
      <ServicesHeader count={items.length} searchActive={active} />
      <ServicesSearchBar value={query} onChange={setQuery} />
      <ServicesTable items={items} loading={loading} error={error}
        onToggleHidden={handleToggleHidden} onToggleTest={handleToggleTest} />
    </Flex>
  );
}

export default Services;
